import React, { useState, useEffect } from "react";
import { Space, Spin } from "antd";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { getSingleConsultation } from "../../../api/index";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Link, useHistory } from "react-router-dom";
import { imageURL } from "../../../api/index";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { ApiCall } from "../../../api/ApiCall";
import Payment from "../../../ConsultaionsForm/Payment";

import "./ViewCons.css";
import { useDispatch } from "react-redux";
import { changeSelectedChat } from "../../../actions/chatActions";
import { handleJoinMeeting } from "../../../helpers";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function ViewConsutations({ match }) {
  // console.log(match.params, "29");
  const token = localStorage.getItem("token");

  const [show, setShow] = useState(false);
  const [pubKeyStripe, setPubKeyStripe] = useState(null);
  const [consultation, setConsultation] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();

  // console.log(consultation, "33");
  useQuery(
    ["singleConsultation", { id: match.params.id }],
    getSingleConsultation,
    {
      retry: 1,
      retryDelay: 500,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setConsultation(data?.data);
        // console.log(data?.data, "43");
      },
    }
  );
  const showMarkAsComplete = () => {
    if (consultation?.status === "completed" && !consultation?.isReviewed)
      return true;

    return false;
  };

  let pubKeyResponse;
  useEffect(async () => {
    try {
      pubKeyResponse = await ApiCall({
        route: "payment/stripe-key",
        token: token,
        params: {},
        verb: "get",
        baseurl: true,
      });
      console.log(pubKeyResponse.response);
      setPubKeyStripe(pubKeyResponse?.response.stripeApiKey);
    } catch (error) {
      console.log(error);
    }
  }, []);

  console.log("consultation in view", consultation);

  let callTypePaymentEnable = false;
  if (consultation.consultationType !== "written_report_analysis") {
    callTypePaymentEnable =
      new Date(consultation?.createdAt).getTime() + 30 * 60 * 1000 >=
      new Date().getTime();
  }

  console.log(
    new Date(consultation?.createdAt).getTime() + 30 * 60 * 1000 >
      new Date().getTime()
  );

  return (
    <div className="main_account">
      {consultation?._id ? (
        <>
          <FormControl className="account_dash" noValidate autoComplete="off">
            <span className="personalInfoBox">
              <div
                className="personal"
                style={{ paddingLeft: "0px", paddingBottom: "0px" }}
              >
                Personal Info
              </div>
              {showMarkAsComplete() && (
                <div style={{ marginTop: "20px" }}>
                  <Link to={`/review/${match.params.id}`} className="up_btn">
                    Review
                  </Link>
                </div>
              )}
            </span>
            <div className="div1_textfield">
              <TextField
                required
                id="filled-required"
                label="First Name"
                disabled
                defaultValue="____"
                variant="filled"
                value={consultation?.firstName}
              />
              <TextField
                required
                id="filled-required"
                label="Last Name"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.lastName}
              />

              <TextField
                required
                id="filled-required"
                label="E-Mail"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.email}
              />
              <TextField
                required
                id="filled-required"
                label="Phone Number"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.phoneNumber}
              />
              <TextField
                required
                id="filled-required"
                label="Date of Birth"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.dateOfBirth}
              />
              <TextField
                className="viewfield"
                required
                id="filled-required"
                label="Age"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.ageInYear}
              />
              {/* <TextField
                className="viewfield"
                required
                id="filled-required"
                label="Address"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.ageInYear}
              /> */}

              <TextField
                required
                id="filled-required"
                label="State"
                defaultValue="California"
                variant="filled"
                disabled
                value={consultation?.state}
              />
              <TextField
                required
                id="filled-required"
                style={{}}
                label="Country"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.city}
              />
              <TextField
                required
                id="filled-required"
                label="Gender"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.gender}
              />
            </div>
          </FormControl>
          <div className="address_div account_dash">
            <div className="addres_he" style={{ paddingLeft: "0px" }}>
              Medical Info
            </div>
            <div>
              <TextField
                required
                id="filled-required"
                label="Comments"
                defaultValue="____"
                variant="filled"
                disabled
                value={consultation?.comment}
              />
              <br />
              <br />
              <div className="attachment-images">
                {consultation?.files?.map((el, i) => (
                  <a
                    href={`${imageURL}/${el?.file_path}`}
                    target="_blank"
                    style={{ marginRight: "10px" }}
                  >
                    {["png", "jpg", "jpeg", "svg"].includes(
                      el?.file_path.split(".").pop()
                    ) ? (
                      <img
                        src={`${imageURL}/${el?.file_path}`}
                        width={100}
                        height={100}
                      />
                    ) : (
                      // <button
                      //   className="up_btn"
                      //   color="primary"
                      //   variant="outline"
                      //   shape="pill"
                      //   type="button"
                      // >
                      //   View Attachment
                      // </button>
                      <img
                        src="/icons/tools/file-download.svg"
                        width={100}
                        height={100}
                      />
                    )}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="password_divv account_dash">
            <div className="password_he" style={{ paddingLeft: "0px" }}>
              {consultation?.consultationType == "written_report_analysis"
                ? "Consultation info"
                : "Scheduled Call Time"}
            </div>
            <div className="password_inputs22" style={{ paddingLeft: "0px" }}>
              {consultation?.consultationType != "written_report_analysis" ? (
                <TextField
                  required
                  id="Time"
                  label="From Time"
                  defaultValue="____"
                  variant="filled"
                  disabled
                  value={moment(consultation?.timeSlot?.startTime).format(
                    "MMMM Do YYYY, h:mm:ss a"
                  )}
                />
              ) : null}

              {consultation?.consultationType != "written_report_analysis" ? (
                <TextField
                  required
                  id="Time"
                  label="To Time"
                  defaultValue="____"
                  variant="filled"
                  disabled
                  value={moment(consultation?.timeSlot?.endTime).format(
                    "MMMM Do YYYY, h:mm:ss a"
                  )}
                />
              ) : null}

              <TextField
                required
                id="Time"
                label="Booking Time"
                defaultValue="____"
                variant="filled"
                disabled
                value={moment(consultation?.createdAt).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
              />
              <TextField
                required
                id="filled-required"
                label="Call type"
                variant="filled"
                className="hello_text"
                disabled
                value={consultation?.consultationType}
              />
            </div>
          </div>
          {consultation?.status !== "completed" && (
            <div className="password_divv">
              <div className="password_he">Actions</div>
              <div className="update_btn55">
                {consultation?.consultationType === "" && <p></p>}
                {consultation?.chatRoomId?._id &&
                consultation.paymentStatus === "confirmed" ? (
                  <button
                    onClick={() => {
                      if (consultation?.chatRoomId?._id) {
                        dispatch(changeSelectedChat(consultation?.chatRoomId));
                        history.push("/dashboard/messages");
                      }
                    }}
                    className="up_btn"
                  >
                    Message Doctor
                  </button>
                ) : (
                  consultation.paymentStatus === "confirmed" &&
                  "Wait for Doctor Approval."
                )}
                {
                  consultation?.consultationType === "video_call" &&
                    consultation.paymentStatus == "confirmed" && (
                      // (!(
                      //   new Date(consultation?.timeSlot?.endTime) <= new Date()
                      // ) ? (
                      //   !(
                      //     new Date(consultation?.timeSlot?.startTime) <= new Date()
                      //   ) ? (
                      //     <>
                      //       <p style={{ marginTop: "13px" }}>
                      //         Your consultation time will start at{" "}
                      //         {new Date(
                      //           consultation?.timeSlot?.startTime
                      //         ).toLocaleString()}
                      //       </p>
                      //     </>
                      //   ) : (
                      <button
                        onClick={() =>
                          handleJoinMeeting(
                            consultation,
                            consultation.userId._id,
                            true,
                            history
                          )
                        }
                        className="up_btn"
                      >
                        Join Video Call
                      </button>
                    )
                  // )
                  // ) : (
                  // <p style={{ marginTop: "13px" }}>
                  //   Your consultation time has ended
                  // </p>

                  //   )
                  // )
                }{" "}
                {consultation.paymentStatus !== "confirmed" && (
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {consultation.consultationType !==
                    "written_report_analysis" ? (
                      new Date(consultation?.createdAt).getTime() +
                        30 * 60 * 1000 >
                        new Date().getTime() && (
                        <>
                          <button
                            style={{
                              maxWidth: "200px",
                            }}
                            className="up_btn"
                            onClick={() => setShow(true)}
                          >
                            Pay Now
                          </button>
                          <span style={{ color: "red", textAlign: "center" }}>
                            Please complete the payment within 30 minutes of
                            booking the consultation.
                          </span>
                        </>
                      )
                    ) : (
                      <>
                        <button
                          style={{
                            maxWidth: "200px",
                          }}
                          className="up_btn"
                          onClick={() => setShow(true)}
                        >
                          Pay Now
                        </button>
                        <span style={{ color: "red", textAlign: "center" }}>
                          Please complete the payment to get servies
                        </span>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {show ? (
            <Payment
              temp={
                consultation?.consultationType !== "written_report_analysis"
                  ? { data: consultation }
                  : consultation
              }
              consultationType={consultation?.consultationType}
              show={show}
              setStep={setShow}
              setShow={setShow}
              amount={consultation.paidAmount}
              price={consultation.paidAmount}
              pubKeyStripe={pubKeyStripe}
            />
          ) : null}
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ViewConsutations;
